var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',{attrs:{"gutter":[16, 16]}},[_c('a-col',{attrs:{"span":24}},[_c('v-chart',{ref:"ei",staticStyle:{"height":"300px"},attrs:{"option":_vm.option}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }